import { render, staticRenderFns } from "./EventAdmin.vue?vue&type=template&id=e96b7f4a&scoped=true"
import script from "./EventAdmin.vue?vue&type=script&lang=js"
export * from "./EventAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e96b7f4a",
  null
  
)

export default component.exports